// Which services each audience sees, in the order they are shown. Ids only:
// the numbers themselves live in services.js.
//
// young: the Vibe apps (readers from their teens up) and Story Threads. The
//   adult list plus four lines for children and teenagers.
// adult: apps whose readers are adults. The same list without Childline UK
//   (under 19s), ISPCC Childline (up to 18), Teen Line (teens) and India's
//   Child Helpline (1098). Lines for young adults that adults also call on
//   behalf of someone (Kids Helpline, Youthline, Kids Help Phone, The Trevor
//   Project) stay in.
//
// The first service in each country is the one a three-line footer shows, so
// it must be a 24/7 line.

const ADULT = {
  australia: ['au-lifeline', 'au-beyond-blue', 'au-kids-helpline'],
  newzealand: ['nz-1737', 'nz-lifeline', 'nz-suicide-crisis', 'nz-youthline'],
  india: ['in-tele-manas', 'in-aasra', 'in-vandrevala', 'in-icall', 'in-women-helpline'],
  uk: ['uk-samaritans', 'uk-shout', 'uk-nhs-111', 'uk-mind-infoline'],
  ireland: ['ie-samaritans', 'ie-text-about-it', 'ie-pieta', 'ie-aware'],
  canada: ['ca-988', 'ca-kids-help-phone', 'ca-cmha'],
  usa: ['us-988', 'us-crisis-text-line', 'us-samhsa', 'us-trevor']
};

const YOUNG = {
  australia: ['au-lifeline', 'au-beyond-blue', 'au-kids-helpline'],
  newzealand: ['nz-1737', 'nz-lifeline', 'nz-suicide-crisis', 'nz-youthline'],
  india: ['in-tele-manas', 'in-aasra', 'in-vandrevala', 'in-icall', 'in-child-helpline', 'in-women-helpline'],
  uk: ['uk-samaritans', 'uk-shout', 'uk-nhs-111', 'uk-mind-infoline', 'uk-childline'],
  ireland: ['ie-samaritans', 'ie-text-about-it', 'ie-pieta', 'ie-aware', 'ie-childline'],
  canada: ['ca-988', 'ca-kids-help-phone', 'ca-cmha'],
  usa: ['us-988', 'us-crisis-text-line', 'us-samhsa', 'us-teen-line', 'us-trevor']
};

export const LISTS = { adult: ADULT, young: YOUNG };
